<app-content-auth>
	<app-recovery-password></app-recovery-password>
</app-content-auth>
